export const loadCallMode = () => import("@/pages/employee/CallMode");
